/** Which clicks an analytics surface counts; absent means all of them. A click
 *  the classifier never evaluated is in neither member. */
export enum BotClickFilter {
  BOT = "bot",
  HUMAN = "human",
}
